'use client';
import styles from './404.module.scss';
import { Button, Result } from 'antd';
import Image from 'next/image';
import errorStateLight from 'assets/images/results/404-light.svg';
import errorStateDark from 'assets/images/results/404-dark.svg';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { useRouter } from 'next/navigation';
import { ThemeEnum } from 'types';
import { PATH } from 'data';

const Error404Comp: React.FC = () => {
    const { theme } = useContext(GlobalContext);
    const router = useRouter();

    return (
        <div className={`${styles['alo-ejare-404']} flex-column`}>
            <div>
                <Result
                    icon={
                        <Image
                            className={styles.image}
                            src={theme === ThemeEnum.dark ? errorStateDark : errorStateLight}
                            alt="error image"
                        />
                    }
                    title={'صفحه مورد نظر یافت نشد'}
                    className="p-0"
                    subTitle={'صفحه ای مطابق با آدرس مورد نظر شما وجود ندارد. لطفا آدرس را بررسی و مجددا اقدام نمایید'}
                    extra={
                        <div className="g-1 center-content">
                            <Button type="default" size="small" className="ph-2-i" onClick={() => router.back()}>
                                بازگشت
                            </Button>
                            <Button
                                type="primary"
                                size="small"
                                className="ph-2-i"
                                onClick={() => router.push(PATH.home)}
                            >
                                صفحه اصلی
                            </Button>
                        </div>
                    }
                />
            </div>
        </div>
    );
};
export default Error404Comp;
